// Mock data for INTERPACK A.Ş website

export const companyInfo = {
  name: "INTERPACK A.Ş",
  tagline: "Sürdürülebilir Ambalaj Çözümlerinde Öncü",
  phone: "+90 212 881 1915",
  email: "info@interpacktr.com",
  salesEmail: "marketing@interpacktr.com",
  address: "Sinanoba Mah. İbrahimzade Cad. Sahil Tepe Villaları No:46/6 PK:34535 Büyükçekmece / İSTANBUL",
  workingHours: {
    weekdays: "Pazartesi - Cuma: 09:00 - 18:00",
    weekend: "Cumartesi - Pazar: Kapalı"
  },
  foundedYear: 2005,
  logo: "https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/dutu8vlv_logo.jpg"
};

export const aboutText = {
  title: "Hakkımızda",
  subtitle: "21 Yıllık Tecrübe ve Kalite",
  headline: "KALİTE BİR TESADÜF DEĞİLDİR",
  description: "21 yıllık deneyimi ile Interpack Ambalaj, Türkiye'nin ofset baskılı karton kutu ve litografik lamine kutu sektörlerinde önde gelen ambalaj üreticilerinden biridir. Renk yönetim sistemi ile entegre edilmiş son teknoloji makine parkı ile donatılmış olan Interpack Ambalaj, yurt içinde ve yurt dışında ofset baskılı kutu ambalaj sektöründe kendini kilit bir oyuncu olarak konumlandırmıştır.",
  description2: "Merkezi İstanbul'da bulunan Interpack Ambalaj, limana yakınlığı ve uluslararası ticaret tecrübesi nedeniyle ihracat için de tercih edilmektedir. Interpack Ambalaj şu anda ürünlerinin çoğunu çeşitli kıtalardan gelen uluslararası müşteriler için üretmektedir.",
  description3: "Hem ofset hem de dijital baskı çözümleri ile kutu ambalaj sektöründe adından söz ettiren Interpack Ambalaj, folyo, kabartma ve metalize UV baskılı kutular gibi çeşitli uygulamalarla müşterilerine rakiplerinden sıyrılma fırsatı sunmaktadır.",
  description4: "Interpack Ambalaj, Amerikan kutuları (A-box), otomatik dolum tepsileri, otomatik dipli kutular, 1-2-3 tabanlı kutular ve 4 nokta ve 6 nokta yapıştırmalı kutular dahil olmak üzere geniş bir kutu ambalaj seçeneği yelpazesi ile ürünlerini farklılaştırmayı hedeflemektedir. Interpack Ambalaj, son yıllarda büyük markalar için vazgeçilmez hale gelen POP display stand üretiminde önde gelen şirketlerden biridir.",
  description5: "Gıda ve içeceklerden medikal ürünlere ve kozmetiğe, ev aletlerinden hayvan ürünlerine kadar geniş bir yelpazede kutu ambalaj hizmetleri sunan Interpack Ambalaj, soft-touch vernik, spot vernik ve UV vernik gibi çeşitli yüzey işlemleri ile müşterilerinin ürünlerinin görsel çekiciliğini artırarak, ambalajın bir markayı temsil etmek için en önemli araç olduğunu göstermektedir.",
  description6: "Yenilikçi ve müşteri odaklı yaklaşımı ile Interpack Ambalaj, ürünlerinin zamanında ve istenilen kalitede müşterilere ulaşmasını sağlamak için mümkün olan en iyi hizmeti ve üretimi sunmaktadır.",
  mission: "En yüksek kalite standartlarında, çevre dostu ve yenilikçi ambalaj çözümleri üreterek müşterilerimize değer katmak ve uluslararası pazarda lider konumumuzu güçlendirmek.",
  vision: "Sürdürülebilir üretim anlayışı ve yenilikçi teknolojilerle, Avrupa ve dünya genelinde tercih edilen önde gelen ambalaj tedarikçilerinden biri olmak.",
  values: [
    { title: "Kalite", description: "Uluslararası standartlarda üretim" },
    { title: "İnovasyon", description: "Sürekli gelişim ve yenilik" },
    { title: "Müşteri Odaklılık", description: "Zamanında ve kusursuz teslimat" },
    { title: "Sürdürülebilirlik", description: "Çevre dostu üretim süreçleri" }
  ]
};

export const aboutTextEN = {
  title: "About Us",
  subtitle: "21 Years of Experience and Quality",
  headline: "QUALITY IS NO ACCIDENT",
  description: "With 21 years of experience, Interpack Packaging is one of Turkey's leading packaging manufacturers in the offset-printed cardboard box and lithographic-laminated box sectors. Equipped with a state-of-the-art machine park integrated with a color management system, Interpack Packaging has established itself as a key player in the offset-printed box packaging sector both domestically and internationally.",
  description2: "Headquartered in Istanbul, Interpack Packaging is also preferred for exports due to its proximity to the port and its experience in international trade. Interpack Packaging currently produces most of its products for international customers from various continents.",
  description3: "Having made a name for itself in the box packaging sector with both offset and digital printing solutions, Interpack Packaging offers its customers the opportunity to stand out from competitors with various applications such as foil, embossed, and metallized UV-printed boxes.",
  description4: "Interpack Packaging aims to differentiate its products with a wide range of box packaging options, including American boxes (A-box), automatic filling trays, automatic bottom-locking boxes, 1-2-3-base boxes, and 4-point and 6-point glued boxes. Interpack Packaging is one of the leading companies in the production of POP display stands, which have become indispensable for major brands in recent years.",
  description5: "Offering box packaging services across a broad spectrum—from food and beverages to medical products and cosmetics, and from household appliances to animal products—Interpack Packaging enhances the visual appeal of its customers' products through various surface treatments such as soft-touch varnish, spot varnish, and UV varnish, thereby demonstrating that packaging is the most important tool for representing a brand.",
  description6: "With its innovative and customer-focused approach, Interpack Packaging provides the best possible service and production to ensure its products reach customers on time and at the desired quality.",
  mission: "To add value to our customers by producing environmentally friendly and innovative packaging solutions at the highest quality standards and to strengthen our leading position in the international market.",
  vision: "To be one of the leading packaging suppliers preferred throughout Europe and the world with a sustainable production approach and innovative technologies.",
  values: [
    { title: "Quality", description: "Production at international standards" },
    { title: "Innovation", description: "Continuous development and innovation" },
    { title: "Customer Focus", description: "On-time and flawless delivery" },
    { title: "Sustainability", description: "Environmentally friendly production processes" }
  ]
};

export const productCategories = [
  {
    id: 1,
    name: "Kedi ve Köpek Mama Kutuları",
    slug: "pet-food",
    description: "Pet food sektörü için dayanıklı, hijyenik ve çevre dostu ambalajlar",
    products: [
      "Kedi Maması Kutuları",
      "Köpek Maması Ambalajları",
      "Mama Etiketleri",
      "Pet Aksesuar Kutuları"
    ],
    icon: "PawPrint"
  },
  {
    id: 2,
    name: "Kedi Kumu",
    slug: "cat-litter",
    description: "Kedi kumu için sağlam, taşıma kolaylığı sağlayan ambalaj çözümleri",
    products: [
      "5 Kg Kedi Kumu Kutuları",
      "10 Kg Kedi Kumu Ambalajları",
      "Premium Kedi Kumu Kutuları",
      "Özel Tasarım Etiketler"
    ],
    icon: "Package"
  },
  {
    id: 3,
    name: "Elektrikli Ev Aletleri",
    slug: "elektrikli-ev-aletleri",
    description: "Beyaz eşya ve küçük ev aletleri için dayanıklı, koruyucu ambalaj çözümleri",
    products: [
      "Buzdolabı Ambalaj Kutuları",
      "Çamaşır Makinesi Kutuları",
      "Mikser ve Blender Kutuları",
      "Elektrikli Süpürge Ambalajları"
    ],
    icon: "Plug"
  },
  {
    id: 4,
    name: "Ev Tekstil",
    slug: "ev-tekstil",
    description: "Ev tekstil ürünleri için şık ve fonksiyonel ambalaj tasarımları",
    products: [
      "Nevresim Takımı Kutuları",
      "Havlu Setleri Ambalajları",
      "Perde ve Fon Kutuları",
      "Battaniye Ambalajları"
    ],
    icon: "Home"
  },
  {
    id: 5,
    name: "Otomotiv",
    slug: "otomotiv",
    description: "Otomotiv yedek parça ve aksesuarları için özel tasarım ambalajlar",
    products: [
      "Yedek Parça Kutuları",
      "Oto Aksesuar Ambalajları",
      "Lastik Ambalaj Çözümleri",
      "Filtre ve Motor Yağı Kutuları"
    ],
    icon: "Car"
  },
  {
    id: 6,
    name: "Gıda",
    slug: "gida",
    description: "Gıda güvenliği standartlarında, hijyenik ambalaj sistemleri",
    products: [
      "Kuru Gıda Kutuları",
      "Şekerleme Ambalajları",
      "Baharat ve Çay Kutuları",
      "Pastane Ürün Kutuları"
    ],
    icon: "Apple"
  },
  {
    id: 7,
    name: "Oyuncak",
    slug: "oyuncak",
    description: "Interpack Ambalaj'ın oyuncak kutuları, peluş oyuncaklardan Lego tipi ürünlere, çeşitli oyuncaklara kadar geniş bir yelpazede üretilen renkli ve dikkat çekici ambalaj çözümleridir. Bu kutular, yüksek kaliteli ofset baskı teknolojisiyle üretilir. Rafta ürünün öne çıkmasını sağlar, satışları artırır ve oyuncağa önemli bir katma değer katar. Interpack Ambalaj, çevreye duyarlı üretim süreçleriyle sürdürülebilirliğe önem verirken, çocukların yaratıcılığını ve hayal gücünü destekleyen yenilikçi, eğlenceli tasarımlar sunar. Uzman kadrosu ve modern makine parkuru sayesinde her türlü özel tasarım oyuncak kutusunu farklı boyut, şekil ve yapı seçenekleriyle gerçekleştirebilir. Ortaya çıkan kutular, sadece çocuklar için değil, yetişkinlerin de ilgisini çeken görsel ve kaliteli ambalajlardır. Kısaca: Oyuncaklarınız için hem göze hitap eden, hem kaliteli hem de çevre dostu kutu arıyorsanız, Interpack Ambalaj'ın oyuncak kutuları en iyi seçeneklerden biridir.",
    products: [
      "Peluş Oyuncak Kutuları",
      "Eğitici Oyuncak Ambalajları",
      "Bebek Ürünleri Kutuları",
      "Puzzle ve Oyun Setleri"
    ],
    icon: "Gamepad2"
  },
  {
    id: 8,
    name: "Deterjan ve Temizlik Kutuları",
    slug: "deterjan-temizlik",
    description: "Temizlik sektörü için yüksek mukavemetli, dayanıklı ve fonksiyonel ambalaj çözümleri",
    products: [
      "Deterjan Kutuları",
      "Yumuşatıcı Ambalajları",
      "Temizlik Ürünleri Kutuları",
      "Bulaşık Makinesi Ürünleri"
    ],
    icon: "Sparkles"
  },
  {
    id: 9,
    name: "Kağıt Saplı Kutular",
    slug: "kagit-sapli-kutular",
    description: "%100 kağıttan üretilmiş, 15 kg taşıma kapasiteli, FDA onaylı sürdürülebilir ambalaj çözümleri",
    products: [
      "Kedi Kumu Kutuları",
      "Deterjan Kutuları",
      "Elektrikli Ev Aletleri",
      "Kedi & Köpek Maması Kutuları",
      "Şarap Kutuları",
      "Kargo Kutuları"
    ],
    icon: "Package"
  }
];

export const productionProcesses = [
  {
    id: 1,
    title: "Tasarım ve Prototip",
    description: "Müşteri ihtiyaçlarına göre özel tasarım ve prototip üretimi. CAD yazılımları ile 3D modelleme.",
    step: "01"
  },
  {
    id: 2,
    title: "Kalıp Hazırlama",
    description: "Son teknoloji CNC makinelerle hassas kalıp üretimi ve hazırlık işlemleri.",
    step: "02"
  },
  {
    id: 3,
    title: "Ofset Baskı",
    description: "Yüksek kaliteli ofset baskı makineleriyle, canlı ve kalıcı renkler.",
    step: "03"
  },
  {
    id: 4,
    title: "Kesim ve Katlama",
    description: "Otomatik kesim ve katlama makineleriyle hızlı ve hassas işlem.",
    step: "04"
  },
  {
    id: 5,
    title: "Laminasyon ve Kaplama",
    description: "Mat, parlak veya selektif UV laminasyon seçenekleriyle özel yüzey işlemleri.",
    step: "05"
  },
  {
    id: 6,
    title: "Kalite Kontrol",
    description: "Her aşamada titiz kalite kontrolü ve son ürün onayı.",
    step: "06"
  }
];

export const certifications = [
  {
    id: 1,
    name: "ISO 9001:2015",
    description: "Kalite Yönetim Sistemi",
    year: "2024"
  },
  {
    id: 2,
    name: "ISO 14001:2015",
    description: "Çevre Yönetim Sistemi",
    year: "2024"
  },
  {
    id: 3,
    name: "FSC Sertifikası",
    description: "Sürdürülebilir Orman Yönetimi",
    year: "2023"
  },
  {
    id: 4,
    name: "ISO 22000",
    description: "Gıda Güvenliği Yönetim Sistemi",
    year: "2024"
  }
];

export const stats = [
  { label: "Yıllık Deneyim", value: "20+", icon: "Award" },
  { label: "Mutlu Müşteri", value: "500+", icon: "Users" },
  { label: "Üretim Kapasitesi", value: "1M+", unit: "adet/ay", icon: "Package" },
  { label: "İhracat Ülkesi", value: "15+", icon: "Globe" }
];

export const testimonials = [
  {
    id: 1,
    name: "Ahmet Yılmaz",
    company: "Ev Aletleri A.Ş.",
    text: "Interpack Ambalaj ile çalışmak bizim için harika bir deneyim oldu. Kaliteli ürünler ve zamanında teslimat.",
    rating: 5
  },
  {
    id: 2,
    name: "Ayşe Demir",
    company: "Pet Foods Ltd.",
    text: "Mama kutularımız için özel tasarım yaptılar. Müşterilerimizden çok olumlu geri dönüşler alıyoruz.",
    rating: 5
  },
  {
    id: 3,
    name: "Mehmet Kaya",
    company: "Tekstil Group",
    text: "Profesyonel yaklaşımları ve çevre dostu üretim anlayışları bizi çok etkiledi.",
    rating: 5
  }
];
